export default __webpack_public_path__ + "static/media/drive-on-mountain.8d04a46a.svg";